import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ImageGalleryBlock3 as Block } from "./ImageGalleryBlock3";
import { defaultData } from "./ImageGalleryBlock3DefaultData";
import { meta } from "./ImageGalleryBlock3Metadata";
import previewImage from "./image_gallery_block_3_preview.png";

export const ImageGalleryBlock3: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: previewImage,
  },
  defaultData,
  meta,
};
